export default "__VITE_ASSET__13718eb0__"